import { render, staticRenderFns } from "./TheTechnology.vue?vue&type=template&id=0cd8f062"
import script from "./TheTechnology.vue?vue&type=script&lang=js"
export * from "./TheTechnology.vue?vue&type=script&lang=js"
import style0 from "./TheTechnology.vue?vue&type=style&index=0&id=0cd8f062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports